import { service } from '@ember/service'
import { assert } from '@ember/debug'
import GravityV3Adapter from 'teacher-ui-client/adapters/gravity/v3-adapter'
import type SessionService from 'teacher-ui-client/services/session'

export default class SchoolRolloverAdapter extends GravityV3Adapter {
  @service session!: SessionService

  pathForType() {
    const { currentSchool } = this.session

    assert('currentSchool.id missing', currentSchool?.id)

    return `schools/${currentSchool.id}/rollovers`
  }
}
